import { isLoggedUserGlobalEditor, getUser } from '~src/user';
import { getMetadata } from '~loader/loader-utils';
import { getState } from '../../state';
import { onAddQuoteToCanvas } from './onAddQuoteToCanvas';
import { getCategoryFromEvent } from './getCategoryFromEvent';
import { filterQuotes } from './filterQuotes';
import $ from 'jquery';

export const displaySidebarQuotes = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const { user } = await getUser();

  const metadata = getMetadata();

  const defaultCategory = getCategoryFromEvent({
    event: metadata.templatesCategoryName,
    project: metadata.projectTypeName,
    availableCategories: Object.keys(window.editorConfig.sidebarQuotes.items),
  });

  const currentCategory = getState(
    'sidebarCurrentQuotesCategory',
    defaultCategory
  );

  const quotes = window.editorConfig.sidebarQuotes.items[currentCategory];

  let quoteNumeber = 0;

  if (!quotes) {
    const html =
      '<div class="text-center mt-5 mb-4">Nessun testo inserito</div>';
    $('#tab-quotes .items-container-grid-quotes').html(html);
    return;
  }
  const { ids, html } = quotes?.reduce(
    (acc, item) => {
      quoteNumeber++;
      let isUserOwner;
      if (item.org_pointer) {
        if (user.org_pointer.objectId === item.org_pointer.objectId) {
          isUserOwner = true;
        }
      }

      const itemId = `editor-sidebar-add-quotes-${item.objectId}`;
      acc.html += `
              <div class="editor-sidebar-item-container editor-sidebar-quotes-container">
                <div class="editor-sidebar-quote-box" id="${itemId}" data-text="${
        item.testo
      }">
                  <p class="number-block">${quoteNumeber}</p>
                  <p class="text-block">&lsaquo;&lsaquo;${
                    item.testo
                  }&rsaquo;&rsaquo;</p>
                </div>
                ${
                  isGlobalEditor || isUserOwner
                    ? `<div class="option-button-container sidebar-context-menu-trigger bg-color-existing-canvas">
                        <div class="option-button-container-relative">
                          <div class="context-menu context-menu-child sidebar-context-menu bg-color-existing-canvas color-existing-canvas">
                            <div class="item context-menu-child item--danger" data-quote-id="${item.objectId}">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <path fill="currentColor" d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"></path>
                              </svg>
                              Elimina
                            </div>
                          </div>
                        </div>
                      </div>`
                    : ''
                }
              </div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  $('#tab-quotes .items-container-grid-quotes').html(html);

  const filter = $('#input-filter-quotes').val().toLowerCase();
  filterQuotes(filter);

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onAddQuoteToCanvas);
      $('body').on('click', id, onAddQuoteToCanvas);
    });
  }
};
